import Globalize from 'globalize';
import moment from 'moment';
import {configure} from 'vee-validate';
import {localize, setLocale} from '@vee-validate/i18n';
import en from '@vee-validate/i18n/dist/locale/en.json';
import ru from '@vee-validate/i18n/dist/locale/ru.json';

configure({
    generateMessage: localize({
        en,
        ru,
    }),
});

const allSupportedOptions = ['locale', 'country', 'currency', 'measurement'];
const isOptionSupported = (option) => allSupportedOptions.includes(option);

const getRegionalSettings = () => JSON.parse(localStorage.getItem('regional-settings'));
const getCurrentLocale = () => localStorage.getItem('locale');
const getCurrentCountry = () => localStorage.getItem('country');

const getDefaultDateFormat = () => {
    moment.localeData(getCurrentLocale()).longDateFormat('L');
};

const useTimeMeridian = () => {
    moment
        .localeData(getCurrentLocale())
        .longDateFormat('LT')
        .toLowerCase()
        .includes('a');
};

const setRegionalSettings = (settings) => {
    Globalize.locale(settings.locale);
    moment.locale(settings.locale);
    setLocale(settings.locale);
    localStorage.setItem('regional-settings', JSON.stringify(settings));

    for (const option in settings) {
        if (settings.hasOwnProperty(option)) {
            if (!isOptionSupported(option)) {
                console.warn(`Warn: option ${option} may be not supported`);
            }
            localStorage.setItem(option, settings[option]);
        }
    }
};

export {
    getCurrentLocale,
    getCurrentCountry,
    setRegionalSettings,
    getDefaultDateFormat,
    getRegionalSettings,
    useTimeMeridian,
};
